import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { HostConnectionService } from '../../services/host-connection.service';

declare var $: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule,
    CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {

  //private apiUrl = environment.API_URL;
  //isDevMode = !environment.production;
  environment: string = '';
  private hostService = inject(HostConnectionService);

  constructor(private commonService: CommonService, private router: Router,
    private authService: AuthService) {

  }

  userName: any = '';
  ngOnInit() {
    //if (this.isDevMode) {
    //  console.log('Development Mode:', this.apiUrl);
    //} else {
    //  console.log('Production Mode:', this.apiUrl);
    //}
    
    this.commonService.user$.subscribe(credentials => {
      if (credentials) {
        this.userName = credentials.username || '';
      }
    });
  }

  ngAfterViewInit(): void {
    this.loadSideMenuToggleScript();
  }

  closeInteraction() {
    this.hostService.close();
  }

  loadSideMenuToggleScript() {
    const mainWrapper = $('.main-wrapper');
    $(document).on('click', '#hamburger-btn', function () {
      mainWrapper.toggleClass('collapsed');
      if (mainWrapper.hasClass('overlay-menu')) {
        if (mainWrapper.hasClass('collapsed')) {
          $('.overlay-mask').removeClass('open');
        } else {
          $('.overlay-mask').addClass('open');
        }
      }
    });
    $(document).on('click', '.overlay-mask', function () {
      $('#hamburger-btn').trigger('click');
      $('.overlay-mask').removeClass('open');
    });
  }

  ngOnDestroy(): void {

  }

  logout() {
    this.authService.logout();
  }

}
